/**
 * Assert that a value is of type `never`.
 *
 * This is handy when you want to ensure your `switch` statement is exhaustive.
 */
export function assertNever(x: never): never {
  throw new Error(`Unhandled case: ${x}`);
}
